import './ProjectComments.css'

import { useState } from 'react';
import { createProjectComment } from '../../utilities/api/projects';
import ProjectCommentsItem from '../ProjectCommentsItem/ProjectCommentsItem';

export default function ProjectComments({project, user, updateProject}) {
    const [formData, setFormData] = useState({commentText: ''})


    const handleChange = (evt) => {
        const newFormData = {
            ...formData,
            [evt.target.name]: evt.target.value,
        };
        setFormData(newFormData);
    }

    const handleSubmit = async (evt) => {
        evt.preventDefault()
        if (!formData.commentText) {
            return
        }
        const data = {
            ...formData,
            firstName: user.firstName,
            lastName: user.lastName,
            userId: user._id,
            projectId: project._id
        }
        try {
            await createProjectComment(data)
            await updateProject(project.projNum)
            setFormData({
                commentText: ''
            })
        } catch (err) {
            console.log(err)
        }
    }

  return (
    <div className='ProjectComments'>
        <div className='commentsHeading'>
            <span>
                <svg width="22" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.692 3.22625C21.0798 1.13625 17.8337 -0.00165106 14.4884 1.79811e-06C10.5449 1.79811e-06 6.86166 1.51927 4.10796 4.27815C1.44683 6.9477 -0.0115825 10.4724 6.92807e-05 14.2003C0.000159877 16.9335 0.802564 19.6065 2.30776 21.8879L2.32006 21.9054C2.33819 21.9319 2.35696 21.9584 2.37573 21.9843C2.39451 22.0102 2.41781 22.0439 2.42299 22.0523L2.43723 22.0782C2.51038 22.2077 2.56669 22.3656 2.51685 22.5248L1.32449 26.8399C1.27678 27.0003 1.25066 27.1664 1.24681 27.3338C1.24595 27.7741 1.41971 28.1967 1.72999 28.509C2.04027 28.8214 2.46174 28.9979 2.902 29C3.13465 28.9923 3.36392 28.9421 3.57845 28.8518L7.94722 27.2749L8.00224 27.2535C8.12108 27.2036 8.24879 27.1783 8.37768 27.1791C8.49652 27.1794 8.61431 27.2013 8.72529 27.2438C8.83016 27.2846 9.78237 27.649 10.787 27.93C11.622 28.163 13.3595 28.5126 14.7208 28.5126C18.582 28.5126 22.1876 27.0173 24.8727 24.3011C27.5345 21.6056 29 18.0227 29 14.2081C29.0003 13.2289 28.8966 12.2524 28.6906 11.2951C28.0213 8.14784 26.2463 5.2815 23.692 3.22625ZM8.28576 16.5714C7.87607 16.5714 7.47559 16.4499 7.13494 16.2223C6.7943 15.9947 6.5288 15.6712 6.37202 15.2927C6.21524 14.9142 6.17421 14.4977 6.25414 14.0959C6.33407 13.6941 6.53135 13.325 6.82105 13.0353C7.11074 12.7456 7.47983 12.5483 7.88165 12.4684C8.28347 12.3884 8.69996 12.4295 9.07846 12.5863C9.45697 12.743 9.78048 13.0085 10.0081 13.3492C10.2357 13.6898 10.3572 14.0903 10.3572 14.5C10.3572 15.0494 10.1389 15.5763 9.75048 15.9647C9.36201 16.3532 8.83514 16.5714 8.28576 16.5714ZM14.5 16.5714C14.0903 16.5714 13.6899 16.4499 13.3492 16.2223C13.0086 15.9947 12.7431 15.6712 12.5863 15.2927C12.4295 14.9142 12.3885 14.4977 12.4684 14.0959C12.5483 13.6941 12.7456 13.325 13.0353 13.0353C13.325 12.7456 13.6941 12.5483 14.0959 12.4684C14.4977 12.3884 14.9142 12.4295 15.2927 12.5863C15.6712 12.743 15.9947 13.0085 16.2224 13.3492C16.45 13.6898 16.5715 14.0903 16.5715 14.5C16.5715 15.0494 16.3532 15.5763 15.9648 15.9647C15.5763 16.3532 15.0494 16.5714 14.5 16.5714ZM20.7143 16.5714C20.3046 16.5714 19.9041 16.4499 19.5635 16.2223C19.2228 15.9947 18.9573 15.6712 18.8006 15.2927C18.6438 14.9142 18.6028 14.4977 18.6827 14.0959C18.7626 13.6941 18.9599 13.325 19.2496 13.0353C19.5393 12.7456 19.9084 12.5483 20.3102 12.4684C20.712 12.3884 21.1285 12.4295 21.507 12.5863C21.8855 12.743 22.209 13.0085 22.4366 13.3492C22.6642 13.6898 22.7857 14.0903 22.7857 14.5C22.7857 15.0494 22.5675 15.5763 22.179 15.9647C21.7906 16.3532 21.2637 16.5714 20.7143 16.5714Z" fill="#5F6B7A"/>
                </svg>
            </span>
            <span>
                &nbsp;&nbsp;Comments
            </span>
            <span>&nbsp;&nbsp;</span>
            <span className='commentCount'>
            {project.comments.length > 0 ? project.comments.length : 0}
            </span>
        </div>
        <div className='commentsBody'>
            <div className='comments'>
            { project.comments.length > 0 ? 
            project.comments.sort((a, b) => a.createdAt > b.createdAt ? -1 : 1).map((comment, idx) => (
                <ProjectCommentsItem key={idx} comment={comment} />
            ))
            : 
                <div>
                    <h6 className='text-center bg-light p-5'>No Comments</h6>
                </div>
            }
            </div>
            {(project && project.status !== 'completed') &&
            <div className='commentFormContainer'>
                <form onSubmit={handleSubmit} className='commentForm'>
                    <div className='avatar'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
                            <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
                        </svg>
                    </div>
                    <textarea title='Add a new comment' name='commentText' onChange={handleChange} rows={1} className='form-control' placeholder="What's on your mind..." required value={formData.commentText}></textarea>
                    <button type='submit' className="addComment">Add Comment</button>
                </form>
            </div>
            }
        </div>
    </div>
  )
}
